import { parentValueMatchesParentCondition } from './parent-condition-value.js';
/**
 * Resolves which fields are visible given the current form values.
 *
 * A field is visible when it has no parent, or when its parent is visible
 * AND the parent's current value matches parentConditionValue.
 *
 * Uses an iterative fixed-point approach so order in the array does not matter
 * and multi-level nesting is handled correctly.
 *
 * When `id` is present on a value entry, it is preferred over `customFieldId`
 * for parent-value lookup. This ensures correct resolution when the same
 * customFieldId appears across multiple meeting body seat term applications.
 *
 * @returns A record keyed by each field's `id` with a boolean visibility value.
 */
export function resolveVisibility(fields, customFieldValues) {
    const visibility = {};
    let changed = true;
    while (changed) {
        changed = false;
        for (const field of fields) {
            if (field.id in visibility)
                continue;
            if (!field.parentId) {
                visibility[field.id] = true;
                changed = true;
            }
            else {
                const parent = fields.find((f) => f.id === field.parentId);
                if (!parent) {
                    visibility[field.id] = false;
                    changed = true;
                }
                else if (parent.id in visibility) {
                    if (!visibility[parent.id]) {
                        visibility[field.id] = false;
                    }
                    else {
                        const parentValue = customFieldValues.find((v) => v.id != null ? v.id === parent.id : v.customFieldId === parent.customFieldId)?.value;
                        visibility[field.id] = parentValueMatchesParentCondition(parentValue, field.parentConditionValue);
                    }
                    changed = true;
                }
            }
        }
    }
    for (const field of fields) {
        if (!(field.id in visibility)) {
            visibility[field.id] = false;
        }
    }
    return visibility;
}
